<body>
  <div class="grid">
    <div class="grid-item-1">
      <p class="p0">HUB Controller</p><p class="p1">&#9415;</p>
    </div>
    <div class="grid-item-2">
      <p class="p3">Just a reminder - we still need a<br>
        picture of your heating controls<br></p>
    </div>
    <div class="grid-item-3">
      <p class="p2">Happy<br>Saving.</p>
    </div>
    <div class="grid-item-4"></div>
    <div class="grid-item-5">
      <div class="column">
        <form class="example-form">
          <mat-form-field>
            <input matInput placeholder="Email" [formControl]="emailFormControl" [errorStateMatcher]="matcher">
            <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>
          <br><br>
          <p>Please upload a picture of your heating controls</p>
          <input class="filewidth" type="file" (change)="getBase64($event)">
          <br><br>
          <div class="panel">
            <button mat-raised-button color="primary" id="submit" (click)="submit()">Submit</button>
          </div>
        </form>
      </div>
    </div>
    <div class="grid-item-6">
      <p class="p5">Smart </p><p class="p6">Thermostat</p>
    </div>
    <div class="grid-item-7"></div>
    <div class="grid-item-8"></div>
    <div class="grid-item-9"></div>
  </div>
</body>
